import React from 'react';

const StripedTableHeadCell = ({
    id = 'striped-table-head-cell',
    border,
    width,
    height,
    ...props
}) => (
    <th
        {...props}
        id={id}
        style={{
            boxSizing: 'border-box',
            fontWeight: 500,
            borderTop: border,
            borderBottom: border,
            borderRight: border,
            zIndex: 500,
            position: 'relative',
            backgroundColor: 'rgb(255,255,255)',
            width: width,
            minWidth: width,
            maxWidth: width,
            height: height,
            maxHeight: height,
            minHeight: height,
            ...props.style
        }}
    />
);

export default StripedTableHeadCell;
